<template>
    <views class="point-detail">
        <views
            v-show="noData"
            class="point-detail-empty">
            <views class="point-detail-empty-inner">
                <images :src="emptyImg"></images>
                <views class="title">暂无明细</views>
            </views>
        </views>
        <van-list
            v-show="!noData"
            v-model="loadingData"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad">
            <views
                v-for="(item, index) in list"
                :key="index"
                class="point-detail-list">
                <views class="point-detail-list-l">
                    {{ item.source }}<views class="count"> +{{ item.point }}</views> 积分
                </views>
                <views class="point-detail-list-r">{{item.created_at}}</views>
            </views>
        </van-list>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    mixins: [tools],
    data() {
        return {
            loadingData: false,
            finished: false,
            pageNum: 1,
            list: [],
            loadOnce: false, // 尝试加载一次
            emptyImg: require('@/assets/images/empty.png')
        }
    },
    computed: {
        noData() {
            return this.pageNum === 1 && this.list.length === 0 && this.loadOnce
        }
    },
    methods: {
        onLoad() {
            const params = {
                page: this.pageNum,
                page_size: 30
            }
            api.getPointDetailList(params).then((res) => {
                this.loadOnce = true
                if (res.data.list && res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.list.push({ ...item })
                    })
                    this.pageNum++
                    this.loadingData = false
                    if (res.data.list.length < 10) {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
